export const SUPPORTED_FORMATS_CV_FILE = ["application/pdf"];
export const FILE_SIZE_FOR_AVATAR = 5 * 1024 * 1024; //5242880
export const SUPPORTED_FORMATS_AVATAR = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/svg+xml"
];